import { DeleteOutlineOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import {
  useModalConfirm,
  useReportId,
  useReportMenuItems,
  useReportsContext,
  useReportsNavigation,
} from "@ryde/redux";
import {
  ConfirmResult,
  errors,
  Log,
  ReportsApi,
  TOOLTIP_DELAY_BUTTONS,
  warnAndToastSimpleResult,
} from "@ryde/shared";

export const DeleteReportButton: FC = () => {
  const { confirmDialogResult } = useModalConfirm();
  const { t } = useTranslation();
  const { navigateReportsTable } = useReportsNavigation();
  const { fetchReportMenuItems } = useReportMenuItems();
  const { reportId } = useReportId();
  const { reportTitle } = useReportsContext();

  const deleteReportHandler: MouseEventHandler<HTMLButtonElement> = async (
    e,
  ): Promise<void> => {
    e.preventDefault();
    e.stopPropagation();
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message: t(`report.REPORT_ARCHIVE_CONFIRM_MESSAGE`, {
        report: reportTitle,
      }),
    });

    if (confirmationResult !== ConfirmResult.OK) {
      Log.warnAndToast(t("errors.removeReportCanceledByUser"));
      return;
    }

    const result = await ReportsApi.delete(reportId);

    if (!result) {
      Log.warnAndToast(t(errors.common.invalidAPIResponse));
      return;
    }

    if (result?.success) {
      Log.infoAndToast(t("report.REPORT_REMOVED_SUCCESSFULLY"));
      fetchReportMenuItems();

      navigateReportsTable(false);
    } else {
      warnAndToastSimpleResult(result, t);
    }
  };

  return (
    <IconButton
      className="delete_report_button"
      onClick={deleteReportHandler}
      size="small"
    >
      <FramerTooltip
        content={t("general.ARCHIVE")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <DeleteOutlineOutlined className="delete_report_icon" />
      </FramerTooltip>
    </IconButton>
  );
};
